<template>
  <div>
    <CSidebarNavTitle v-if="hasAnyPerms([
      'dashboard.view_feature_shortener',
      'admin.template.list',
      'admin.vertical.list',
      'admin.plan.list',
      'admin.region.list',
      'admin.price_list.list'
    ])">{{ $gettext('Configuration') }}</CSidebarNavTitle>
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['dashboard.view_feature_shortener'])"
      :name="$gettext('Shortener')"
      :to="{name: 'shortener.list'}"
      icon="cip-link-horizontal"
    />
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['admin.template.list'])"
      :name="$gettext('Templates')"
      :to="{name: 'eventTemplate.list'}"
      icon="cip-window-code"
    />
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['admin.vertical.list'])"
      :name="$gettext('Verticals')"
      :to="{name: 'verticalConfiguration.list'}"
      icon="cip-window-code"
    />
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['admin.plan.list'])"
      :name="$gettext('Plans')"
      :to="{name: 'payments.plan.list'}"
      icon="cip-list"
    />
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['admin.region.list'])"
      :name="$gettext('Regions')"
      :to="{name: 'region.list'}"
      icon="cip-globe-04"
    />
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['admin.price_list.list'])"
      :name="$gettext('Price List Template')"
      :to="{name: 'priceListTemplate.list'}"
      icon="cip-doc"
    />
  </div>
</template>

<script>
export default {
  name: 'Configuration'
}
</script>